import { FC, lazy } from 'react';
import { isServer } from 'shared/constants/isServer';
import { FlexBox } from '@brg/ui';

const BacklogModalViewClient: any = isServer ? FlexBox : lazy(() => import('./BacklogModalViewClient'))

export const BacklogModalView: FC<{ onExit: any }> = ({ onExit }) => {
    
    return <BacklogModalViewClient onExit={onExit}/>
};
import { FC, lazy } from 'react';
import { isServer } from 'shared/constants/isServer';
import { FlexBox } from '@brg/ui';

const BacklogModalViewClient: any = isServer ? FlexBox : lazy(() => import('./BacklogModalViewClient'))

export const BacklogModalView: FC<{ onExit: any }> = ({ onExit }) => {
    
    return <BacklogModalViewClient onExit={onExit}/>
};
